import { DOCUMENT_APPROVAL_STATUSES } from '@careerstart/wae-common/schema/models/document/enums/documentApprovalStatuses';
import documentStateStatuses from '@careerstart/wae-common/schema/models/document/enums/documentStateStatuses';
import { DOCUMENT_VALIDITY_STATUSES } from '@careerstart/wae-common/schema/models/document/enums/documentValidityStatuses';
import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

import { FEED_BACK, RED } from '../../../../../../theme/colorConstants';

export const FORM_STATUS_OPTIONS = [
  {
    status: DOCUMENT_APPROVAL_STATUSES.APPROVED,
    labelKey: 'userDetail.employeeDocumentation.formStatus.approved',
    dotColor: FEED_BACK.GREEN_50,
  },
  {
    status: DOCUMENT_APPROVAL_STATUSES.REJECTED,
    labelKey: 'userDetail.employeeDocumentation.formStatus.notApproved',
    dotColor: RED[50],
  },
];

export const FORM_VALIDITY_OPTIONS = [
  {
    status: DOCUMENT_VALIDITY_STATUSES.VALID,
    labelKey: 'userDetail.employeeDocumentation.formValidity.valid',
    iconColor: FEED_BACK.GREEN_50,
  },
  {
    status: DOCUMENT_VALIDITY_STATUSES.INVALID,
    labelKey: 'userDetail.employeeDocumentation.formValidity.notValid',
    iconColor: RED[50],
  },
];

const APPROVAL_WRITE_ALLOWED_LIFECYCLE_STATUSES = {
  [DOCUMENT_APPROVAL_STATUSES.APPROVED]: [
    documentStateStatuses.pendingValidation,
    documentStateStatuses.pendingApproval,
    documentStateStatuses.failedApproval,
  ],
  [DOCUMENT_APPROVAL_STATUSES.REJECTED]: [
    documentStateStatuses.pendingApproval,
    documentStateStatuses.completed,
  ],
};

const VALIDITY_WRITE_ALLOWED_LIFECYCLE_STATUSES = {
  [DOCUMENT_VALIDITY_STATUSES.VALID]: [
    documentStateStatuses.pendingValidation,
    documentStateStatuses.failedValidation,
  ],
  [DOCUMENT_VALIDITY_STATUSES.INVALID]: [
    documentStateStatuses.pendingValidation,
    documentStateStatuses.pendingApproval,
    documentStateStatuses.completed,
  ],
};

export const getFormStatusLabelKey = (status) =>
  FORM_STATUS_OPTIONS.find((option) => option.status === status)?.labelKey;

export const getFormValidityLabelKey = (status) =>
  FORM_VALIDITY_OPTIONS.find((option) => option.status === status)?.labelKey;

export const getReviewStatusLabelKey = (status) =>
  getFormStatusLabelKey(status) || getFormValidityLabelKey(status);

export const canWriteDocumentReviewState = (role) => role === UserRole.ADMIN;

export const canSetApprovalStatus = (document, status) => {
  const allowedLifecycleStatuses = APPROVAL_WRITE_ALLOWED_LIFECYCLE_STATUSES[status];
  if (!allowedLifecycleStatuses) {
    return false;
  }

  const isLifecycleAllowed = allowedLifecycleStatuses.includes(document?.state?.status);
  if (!isLifecycleAllowed) {
    return false;
  }

  if (status === DOCUMENT_APPROVAL_STATUSES.APPROVED) {
    // A document still awaiting validation can be approved directly, before validity is set.
    if (document?.state?.status === documentStateStatuses.pendingValidation) {
      return true;
    }

    return document?.validity?.status === DOCUMENT_VALIDITY_STATUSES.VALID;
  }

  return true;
};

export const canSetValidityStatus = (document, status) => {
  const allowedLifecycleStatuses = VALIDITY_WRITE_ALLOWED_LIFECYCLE_STATUSES[status];
  if (!allowedLifecycleStatuses) {
    return false;
  }

  return allowedLifecycleStatuses.includes(document?.state?.status);
};
